module.exports = __webpack_public_path__ + "media/assets/images/flags/gq-11b8301de15bcac0b692a918b025dc8d.svg";